export default __webpack_public_path__ + "assets/front/scss/user-profile.7a8332f2da8d2d0ae367a9696de64d50.css";